import IncomingShipmentCard from "./IncomingShipmentCard";
export default IncomingShipmentCard;
